<main class="login">
  <section class="login-card" aria-labelledby="denied-title">
    <div class="login-brand">calsium<span></span><small>Cost allocation and Simulation management</small></div>
    <h1 id="denied-title" class="login-title">No access</h1>
    <p class="login-hint"> Please contact your administrator to request access, then sign in again.</p>
    <button type="button" class="login-button" (click)="signOut()">Sign out</button>
  </section>
</main>
